import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Building2 } from 'lucide-react';
import { EmptyState, ErrorAlert, Skeleton } from '@/components/Primitives';
import { useBuilding } from './BuildingContext';

/**
 * Tenant-scoped pages cannot render without a building. This resolves the
 * active tenant once, so no page has to handle a null id defensively.
 */
export function RequireBuilding() {
  const { t } = useTranslation();
  const { activeBuildingId, loading, error } = useBuilding();

  if (loading) {
    return (
      <div style={{ display: 'grid', gap: 14, paddingTop: 14 }}>
        <Skeleton height={120} />
        <Skeleton height={220} />
      </div>
    );
  }

  if (error) {
    return <ErrorAlert message={t(error, { defaultValue: t('errors.unexpected') })} />;
  }

  if (activeBuildingId === null) {
    return <EmptyState icon={Building2} title={t('building.none')} body={t('building.noneBody')} />;
  }

  return <Outlet />;
}
